"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enumerable = void 0;
var Enumerable;
(function (Enumerable) {
    function rangeTo(end) {
        return range(0, end);
    }
    Enumerable.rangeTo = rangeTo;
    function range(start, end) {
        const range = Array(end - start);
        for (let i = start; i < end; i++) {
            range[i - start] = i;
        }
        return range;
    }
    Enumerable.range = range;
})(Enumerable = exports.Enumerable || (exports.Enumerable = {}));
